export default __webpack_public_path__ + "invitation_error.38fbc34.svg";